@import './variables.less';

h1 {
    font-size: 1.75em !important;
}

.navbar {
    padding: .5rem 0rem !important;
}

@media (max-width: @width-sm) {
}
@media (max-width: @width-md) {
}
@media (max-width: @width-lg) {
}
@media (max-width: @width-xl) {
}
